export const modifierList = ['bg-dark', 'color-light'];
